class ESignUp {
  amzSDK: any;
  lambdaPayload: any;
  dialogObj: DialogObj;
  lbHideParams: Array<string>;
  cookieValue: string;
  elementIDs: ElementIDs;
  lambdaClient: any;

  constructor({
    amzSDK,
    lambdaPayload,
    dialogObj,
    lbHideParams,
    cookieValue,
    elementIDs,
  }) {
    if (!amzSDK) throw new Error('"amzSDK" config value is required.');
    if (!lambdaPayload)
      throw new Error('"lambdaPayload" config value is required.');
    if (!dialogObj) throw new Error('"dialogObj" config value is required.');
    let defaultLambdaPayload = {
      region: "US",
      timeZone: "-5",
      language: "EN",
      method: "API",
    };
    let defaultElementIds = {
      lightBoxInput: "#emailAddress1",
      lightBoxBtn: "#emailAddress1btn",
      footerInput: "#emailAddress2",
      footerBtn: "#emailAddress2btn",
      checkoutInput: "#emailAddress",
      homePageInput: "#emailAddress3",
      homePageBtn: "#emailAddress3btn",
      lightBoxBackground: "#emailSignupPopover",
      lightBoxCloseBtn: "#ligtboxClosebtn",
      sweepsBtn: "#sweepsBtn",
      sweepsEmail: "#sweepsEmail",
      sweepsName: "#sweepsName",
      sweepsCheck: "#sweepsCheck",
      sweepsBonvoyCheck: "#sweepsBonvoyCheck",
      landingPageSweepsBtn: "#landingPageSweepsBtn",
      landingPageSweepsEmail: "#landingPageSweepsEmail",
      landingPageSweepsName: "#landingPageSweepsName",
      landingPageSweepsBonvoyCheck: "#landingPageSweepsBonvoyCheck",
      landingPageSweepsCheck: "#landingPageSweepsCheck",
    };
    let defaultDialogObj = {
      btnTxt: "SHOP NOW",
    };
    this.amzSDK = amzSDK;
    this.lambdaPayload = {
      ...defaultLambdaPayload,
      ...lambdaPayload,
    };
    this.dialogObj = {
      ...defaultDialogObj,
      ...dialogObj,
    };
    this.lbHideParams = lbHideParams || ["utm_source=hah"];
    this.cookieValue = cookieValue || "emailSignup";
    this.elementIDs = {
      ...defaultElementIds,
      ...elementIDs,
    };
    this.lambdaClient = this.initLambdaClient();
  }
  // Methods
  initLambdaClient() {
    //Initialize the AWS SDK and return client
    AWS.config.region = this.amzSDK.region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: this.amzSDK.poolId,
    });
    AWS.config.apiVersions = {
      lambda: "2015-03-31",
    };
    AWS.config.update({
      maxRetries: 0,
      httpOptions: {
        timeout: 5000,
        connectTimeout: 5000,
      },
    });
    return new AWS.Lambda();
  }
  getTimeZone() {
    let currDate = new Date();
    return Math.floor((currDate.getTimezoneOffset() / 60) * -1).toString();
  }
  hideLandingPageSweepsForm() {
    $("#sweepstakesFormWrap").fadeOut("slow", function () {
      $("#sweepstakesConfirmation").fadeIn("slow");
    });
  }
  callLambda(
    emailId,
    source,
    showLbMessage,
    callBack = null,
    action = "add",
    name = "",
    campaign?
  ) {
    //Call the remote Lambda function
    this.showLightbox(false);
    if (showLbMessage) {
      dilogBox(this.dialogObj);
      window.scrollTo(0, 0);
    }
    let tz = this.getTimeZone();
    let payload = {
      emailId: emailId,
      source: source,
      timeZone: tz,
      name: name,
      campaign: campaign,
    };
    let lambdaPayload = {
      action: action,
      data: {
        ...this.lambdaPayload,
        ...payload,
      },
    };
    let params = {
      FunctionName: this.amzSDK.functionName,
      Payload: JSON.stringify(lambdaPayload),
    };
    this.lambdaClient.invoke(params, function (err, data) {
      if (callBack) callBack();
    });
  }
  checkQueryVariables() {
    let vars = window.location.search.substring(1).toLowerCase().split("&");
    let paramsPresent = false;
    for (let i = 0; i < this.lbHideParams.length; i++) {
      if (vars.indexOf(this.lbHideParams[i]) > -1) {
        paramsPresent = true;
      }
    }
    return paramsPresent;
  }
  checkDisplayLightbox() {
    let emailCookie = getCookie(this.cookieValue);
    if (emailCookie === null) {
      let paramsPresent = false;
      paramsPresent = this.checkQueryVariables();
      if (paramsPresent) {
        this.showLightbox(false);
      } else {
        this.showLightbox(true);
      }
    }
  }
  showLightbox(show = false) {
      const emailSignupPopoverDiv = document.getElementById("emailSignupPopover");
    if (show) {
      if (emailSignupPopoverDiv) {
        emailSignupPopoverDiv.style.display = "";
        HAHAccessibility.trapFocus({
          container: '.emailFocusTrap', 
          closeElement: '#emailSignupPopover'
        });
      }
    } else {
      if (emailSignupPopoverDiv) {
        emailSignupPopoverDiv.style.display = "none";
      }
      setCookie(this.cookieValue, "emailClosed", 180);
    }
  }
  validateSweeps(name, emailID, checked, recaptchaPassed) {
    let alertMessage = "";
    let nameRegex = /^[a-z ,.'-]+$/i;

    if (!nameRegex.test(name)) alertMessage += "Please enter a valid name. \n";
    if (!validateEmail(emailID))
      alertMessage += "Please enter a valid email address.\n";
    if (!checked) alertMessage += "Please check the sweeps rules checkbox.\n";
    if (!recaptchaPassed) {
      alertMessage += "Please complete re-captcha.";
    }
    if (alertMessage !== "") {
      alert(alertMessage);
      return false;
    }
    return true;
  }
  bindElementHandlers() {
    let footerBtn = $(this.elementIDs.footerBtn);
    let lightBoxBtn = $(this.elementIDs.lightBoxBtn);
    let homePageBtn = $(this.elementIDs.homePageBtn);
    let lightBoxCloseBtn = $(this.elementIDs.lightBoxCloseBtn);
    let lightBoxBackground = $(this.elementIDs.lightBoxBackground);
    let sweepsBtn = $(this.elementIDs.sweepsBtn);
    let landingPageSweepsBtn = $(this.elementIDs.landingPageSweepsBtn);
    if (lightBoxCloseBtn.length) {
      lightBoxCloseBtn.on("click", () => {
        this.showLightbox(false);
      });
    }
    if (lightBoxBackground.length) {
      $(document).on("click", (e) => {
        if ($(e.target).is(lightBoxBackground)) {
          this.showLightbox(false);
        }
      });
    }
    if (lightBoxBtn.length) {
      lightBoxBtn.on("click", () => {
        let emailValue = (<any>$(this.elementIDs.lightBoxInput).val()).trim();
        if (!validateEmail(emailValue)) {
          alert("Please enter a valid email address.");
        } else {
          this.callLambda(emailValue, "lightbox", true);
          setCookie("HAHemailID", emailValue, 180);
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "lightbox",
            event_value: 1,
          });
        }
      });
    }
    if (homePageBtn.length) {
      homePageBtn.on("click", () => {
        let emailValue = (<any>$(this.elementIDs.homePageInput).val()).trim();
        if (!validateEmail(emailValue)) {
          alert("Please enter a valid email address.");
        } else {
          this.callLambda(emailValue, "home", false);
          setCookie("HAHemailID", emailValue, 180);
          $("#ftr-email-signup").fadeOut("slow", function () {
            $("#ftr-email-conf").fadeIn("slow");
          });
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "home",
            event_value: 1,
          });
        }
      });
    }
    if (sweepsBtn.length) {
      sweepsBtn.on("click", () => {
        let sweepsEmail = (<any>$(this.elementIDs.sweepsEmail).val()).trim();
        let sweepsName = (<any>$(this.elementIDs.sweepsName).val()).trim();
        let sweepsChecked = $(this.elementIDs.sweepsCheck).is(":checked");
        let sweepsBonvoyChecked = $(this.elementIDs.sweepsBonvoyCheck).is(
          ":checked"
        );
        let campaign =
          sweepsBonvoyChecked === true ? "202106member" : "202106nonmember";
        if (this.validateSweeps(sweepsName, sweepsEmail, sweepsChecked, 1)) {
          this.callLambda(
            sweepsEmail,
            "lightbox",
            true,
            null,
            "sweepsadd",
            sweepsName,
            campaign
          );
          setCookie("HAHemailID", sweepsEmail, 180);
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "sweeps",
            event_value: 1,
          });
        }
      });
    }
    if (landingPageSweepsBtn.length) {
      landingPageSweepsBtn.on("click", () => {
        let landingPageSweepsEmail = (<any>$(this.elementIDs.landingPageSweepsEmail)
          .val())
          .trim();
        let landingPageSweepsName = (<any>$(this.elementIDs.landingPageSweepsName)
          .val())
          .trim();
        let landingPageSweepsChecked = $(
          this.elementIDs.landingPageSweepsCheck
        ).is(":checked");
        let landingPageSweepsBonvoyChecked = $(
          this.elementIDs.landingPageSweepsBonvoyCheck
        ).is(":checked");
        let v = grecaptcha.getResponse();
        let campaign =
          landingPageSweepsBonvoyChecked === true
            ? "202106member"
            : "202106nonmember";
        if (
          this.validateSweeps(
            landingPageSweepsName,
            landingPageSweepsEmail,
            landingPageSweepsChecked,
            v.length
          )
        ) {
          this.callLambda(
            landingPageSweepsEmail,
            "sweeps",
            true,
            this.hideLandingPageSweepsForm,
            "sweepsadd",
            landingPageSweepsName,
            campaign
          );
          setCookie("HAHemailID", landingPageSweepsEmail, 180);
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "sweeps landing page",
            event_value: 1,
          });
        }
      });
    }
    if (footerBtn.length) {
      footerBtn.on("click", () => {
        let emailValue = (<any>$(this.elementIDs.footerInput).val()).trim();
        if (!validateEmail(emailValue)) {
          alert("Please enter a valid email address.");
        } else {
          this.callLambda(emailValue, "footer", false);
          setCookie("HAHemailID", emailValue, 180);
          $("#ftr-email-signup2").fadeOut("slow", function () {
            $("#ftr-email-conf2").fadeIn("slow");
          });
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "footer",
            event_value: 1,
          });
        }
      });
    }
  }
}

interface DialogObj {
  mainTxt: string;
  secondaryTxt: string;
  btnTxt?: string;
}

interface ElementIDs {
  lightBoxInput: string;
  lightBoxBtn: string;
  footerInput: string;
  footerBtn: string;
  checkoutInput: string;
  homePageInput: string;
  homePageBtn: string;
  lightBoxBackground: string;
  lightBoxCloseBtn: string;
  sweepsBtn: string;
  sweepsEmail: string;
  sweepsName: string;
  sweepsCheck: string;
  sweepsBonvoyCheck: string;
  landingPageSweepsBtn: string;
  landingPageSweepsEmail: string;
  landingPageSweepsName: string;
  landingPageSweepsBonvoyCheck: string;
  landingPageSweepsCheck: string;
}